(function(){
"use strict";

function rewriteSalesNav(){
  var links=[].slice.call(document.querySelectorAll('a[href]'));
  links.forEach(function(link){
    var raw=link.getAttribute("href")||"";
    var isSales=raw==="#/sales"||raw==="#sales"||/\/#\/sales(?:[?&]|$)/.test(link.href||"");
    if(!isSales)return;

    link.setAttribute("href","#/sell-editor");
    link.dataset.kpSellpageNav="1";

    var textNodes=[].slice.call(link.childNodes).filter(function(n){
      return n.nodeType===3 && String(n.nodeValue||"").trim();
    });

    if(textNodes.length){
      textNodes.forEach(function(n){
        if(/Försäljning/i.test(n.nodeValue||""))n.nodeValue=(n.nodeValue||"").replace(/Försäljning/gi,"Säljsida");
      });
    }else{
      var label=link.querySelector(".nav-label,.bn-label,span:not(.icon)");
      if(label&&/Försäljning/i.test(label.textContent||""))label.textContent="Säljsida";
      else if(/Försäljning/i.test(link.textContent||"")){
        var walker=document.createTreeWalker(link,NodeFilter.SHOW_TEXT);
        var node;
        while((node=walker.nextNode())){
          if(/Försäljning/i.test(node.nodeValue||"")){
            node.nodeValue=(node.nodeValue||"").replace(/Försäljning/gi,"Säljsida");
            break;
          }
        }
      }
    }

    link.setAttribute("aria-label","Säljsida");
    if(link.title==="Försäljning")link.title="Säljsida";
  });
}

function sync(){
  if(!document.body)return;
  rewriteSalesNav();
}

var pending=false;
function schedule(){
  if(pending)return;
  pending=true;
  requestAnimationFrame(function(){
    pending=false;
    sync();
  });
}

window.addEventListener("hashchange",function(){setTimeout(sync,50);});
document.addEventListener("DOMContentLoaded",sync);

var app=document.getElementById("app");
if(app&&window.MutationObserver){
  new MutationObserver(schedule).observe(app,{childList:true,subtree:true});
}

setTimeout(sync,300);
})();